const EntityMapPanel = (function () {
  const mapCloseButton = document.querySelector('.js-entity-map-panel-close-btn')
  const mapPanel = document.querySelector('.js-entity-map-overlay')
  const infoSection = document.querySelector('.js-entity-info-content')
  const infoSectionButton = document.querySelector('.js-entity-info-btn')

  const init = () => {
    if (mapCloseButton) {
      mapCloseButton.addEventListener('click', closeMapPanel)
    }
    if (infoSectionButton) {
      infoSectionButton.addEventListener('click', toggleMoreInfoSection)
    }
  }
  // At this stage you can only close the map panel and you will need to refresh the page to open it again.
  const closeMapPanel = () => {
    if (mapPanel) {
      mapPanel.classList.add('c-entity-map__card--hidden')
    }
  }

  const toggleMoreInfoSection = () => {
    if (infoSection.classList.contains('c-entity-info__content--expanded')) {
      closeInfoSection()
    } else {
      openInfoSection()
    }
  }

  const closeInfoSection = () => {
    infoSection.classList.remove('c-entity-info__content--expanded')
    infoSectionButton.ariaExpanded = false
    infoSectionButton.textContent = 'More information'
  }

  const openInfoSection = () => {
    infoSection.classList.add('c-entity-info__content--expanded')
    infoSectionButton.ariaExpanded = true
    infoSectionButton.textContent = 'Hide information'
  }

  return {
    init: () => {
      if (mapCloseButton && infoSectionButton) {
        init()
      }
    },
  }
})()

export default EntityMapPanel
